import { render, staticRenderFns } from "./NotifyPurpose.vue?vue&type=template&id=07dadd72&"
import script from "./NotifyPurpose.vue?vue&type=script&lang=js&"
export * from "./NotifyPurpose.vue?vue&type=script&lang=js&"
import style0 from "./NotifyPurpose.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports